









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import { deepClone } from '@/util/deepClone';

@Component({
  components: {},
})
export default class ChoosePeople extends Vue {
  private deptNameText: any = ''; // 部门名称
  private deptList: any = []; // 部门数据 上下级
  private innerList: any = []; // 部门下的人员

  private deptListAll: any = []; // 所有 部门数据
  private staffListAll: any = []; // 所有 部门数据
  private innerListOrigin: any = []; // 内部人员筛选之前的数据

  private visible = false; // 弹框显示
  private type = ''; // 区分单选 多选
  private isVisible = true; // 部门 、 人员显示
  private inputDeptOrStaff = 'dept'; // 输入时 是部门还是人员列表
  private input: any = ''; // 人员名称搜索
  private checkedInnerText: any = [];
  private staffLimit: any = 0;

  private getList() {
    userServe
      .getStaffOfDept({})
      .then((res: any) => {
        const arrDept: any = res.data.filter((item: any) => item.type === 'dept');
        this.deptListAll = arrDept;
        const arrStaff: any = res.data.filter((item: any) => item.type === 'staff');
        this.staffListAll = arrStaff;
        arrDept.forEach((dept: any) => {
          this.$set(dept, 'staffList', []);
          arrStaff.forEach((staff: any) => {
            if (dept.id === staff.pid) {
              dept.staffList.push(staff);
            }
          });
        });
        this.deptList = arrayToTree(arrDept);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * 打开窗口
   */
  private async showDialog(data: any, type: any, limit?: any) {
    this.staffLimit = limit || 0;
    this.getList();
    this.visible = true;
    this.checkedInnerText = data;
    this.type = type;
  }

  selectionRow(selection: any, row?: any) {
    if (this.type === 'single') {
      this.checkedInnerText = [];
      (this.$refs.multipleInnerTable as any).clearSelection();
    }
    const selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    if (selected) {
      (this.$refs.multipleInnerTable as any).toggleRowSelection(row, true);
      this.checkedInnerText.push(row);
    } else {
      this.checkedInnerText.forEach((re: any, index: any) => {
        if (row.id === re.id) {
          this.checkedInnerText.splice(index, 1);
        }
      });
    }
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.visible = false;
    this.isVisible = true;
    this.checkedInnerText = [];
    this.deptNameText = '';
    this.input = '';
    (this.$refs.multipleInnerTable as any).clearSelection();
  }

  private save() {
    let dataArr: any = [];
    if (this.checkedInnerText.length) {
      dataArr = this.checkedInnerText.map((item: any) => {
        return {
          id: item.id,
          name: item.name,
        };
      });
    } else {
      dataArr = [];
    }
    if (dataArr.length && this.staffLimit && dataArr.length > this.staffLimit) {
      return this.$message.error(`人员数量不能大于${this.staffLimit}`);
    }
    this.$emit('getCheckDeptStaffData', dataArr);
    this.hideDialog();
  }

  /**
     @description: 对下级已选的数据进行删除
     @author: cxf
     @update: cxf 2021/7/12 15:15
     **/
  private handleCloseTag(data: any, index: any) {
    this.checkedInnerText.splice(index, 1);
    this.innerList.forEach((elem: any) => {
      if (data.id === elem.id) {
        (this.$refs.multipleInnerTable as any).toggleRowSelection(elem, false);
      }
    });
  }

  private nextList(data: any) {
    this.isVisible = false;
    this.deptNameText = data.name;
    this.innerListOrigin = data.staffList;
    this.inputDeptOrStaff = 'staff';
    if (this.input) {
      this.innerList = data.staffList.filter((item: any) => item.name.indexOf(this.input) > -1);
    } else {
      this.innerList = data.staffList;
    }
    this.$nextTick(() => {
      this.innerList.forEach((elem: any) => {
        this.checkedInnerText.forEach((item: any) => {
          if (item.id === elem.id) {
            (this.$refs.multipleInnerTable as any).toggleRowSelection(elem, true);
          }
        });
      });
    });
  }

  private backDeptList() {
    this.deptNameText = '';
    this.inputDeptOrStaff = 'dept';
    this.isVisible = true;
  }

  private searchStaff() {
    if (this.inputDeptOrStaff === 'dept') {
      if (this.input) {
        this.isVisible = false;
        this.innerList = this.staffListAll.filter((item: any) => item.name.indexOf(this.input) > -1);
      } else {
        this.isVisible = true;
      }
    } else {
      const innerListDeepClone: any = deepClone(this.innerListOrigin);
      if (this.input) {
        this.innerList = innerListDeepClone.filter((item: any) => item.name.indexOf(this.input) > -1);
      } else {
        this.innerList = this.innerListOrigin;
      }
    }
  }
}
